import type { RefObject } from 'react';

const eventsToHandle = ['click', 'touchstart'] as const;

/**
 * Roughly based on https://github.com/Pomax/react-onclickoutside?tab=readme-ov-file#usage
 * @param contentRef Should be attached to the top-level element of your component
 * @param handler Is called whenever the user clicks outside the element
 * @return function that will remove the event listeners. Add this to your component cleanup.
 */
export function listenForOutsideClicks(contentRef: RefObject<HTMLElement>, handler: () => void) {
    const eventHandler = (evt: Event) => {
        if (evt.target instanceof Node && !contentRef.current?.contains(evt.target)) {
            handler();
        }
    };

    eventsToHandle.forEach(type => {
        document.addEventListener(type, eventHandler);
    });

    return () => {
        eventsToHandle.forEach(type => {
            document.removeEventListener(type, eventHandler);
        });
    };
}
